import { PartialBlock } from '@blocknote/core';
import { BlockNoteView } from '@blocknote/mantine';
import { useCreateBlockNote } from '@blocknote/react';
import React, { useEffect, useState } from 'react';
import "@blocknote/core/fonts/inter.css";
import "@blocknote/mantine/style.css";

interface EditorProps {
    content: PartialBlock[];
    isEditable: boolean;
    setContent?: (content: PartialBlock[]) => void;
}

const Editor: React.FC<EditorProps> = ({ content, isEditable, setContent }) => {
    const [internalContent, setInternalContent] = useState(content);

    const theme = {
        colors: {
          editor: {
            text: 'text-primary',
            background: 'bg-gray-50',
          },
        }
      };

    const editor = useCreateBlockNote({
        initialContent: internalContent.length > 0 ? internalContent : [{ type: 'paragraph', content: '' }] as PartialBlock[],
    });

    useEffect(() => {
        if (!isEditable || !setContent) return;

        const handleContentChange = () => {
            const updatedContent = [...editor.document];
            setContent(updatedContent);
            setInternalContent(updatedContent);
        };

        const observer = new MutationObserver(handleContentChange);

        const editorElement = document.querySelector(".blocknote-container");

        if (editorElement) {
            observer.observe(editorElement, { childList: true, subtree: true, characterData: true });
        }

        return () => observer.disconnect();

    }, [editor, isEditable, setContent, internalContent]);

    return (
        <BlockNoteView editor={editor} editable={isEditable} theme={theme} className={isEditable ? 'blocknote-container' : ''} />
    );
};

export default Editor;